import type { Contact } from '../../domain/contact';
import type { CollectedDataItem } from '../../domain/message';

import SharedDataExtractionService from './sharedDataExtractionService';

const createHubspotDataExtractionService = () => {
  const { extractName, extractContentByKey, extractCompanyName, extractCompanyDomain, extractCompanyDomainFromEmail } =
    SharedDataExtractionService;

  const extractContactInfo = (collectedData: CollectedDataItem[]): Partial<Contact> => {
    const name = extractName(collectedData);
    const email = extractContentByKey(collectedData, 'Contact Email');
    const companyDomain = extractCompanyDomain(collectedData);
    const companyDomainFromEmail = typeof email === 'string' ? extractCompanyDomainFromEmail(email) : undefined;
    const companyName = extractContentByKey(collectedData, 'Company Name') as string;

    return {
      name,
      site: companyDomain ?? companyDomainFromEmail,
      companyName,
    };
  };

  return { extractCompanyDomain, extractCompanyName, extractContactInfo };
};

const HubspotDataExtractionService = createHubspotDataExtractionService();

export default HubspotDataExtractionService;
